module.exports = __webpack_public_path__ + "static/img/500.990ae4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error/500.svg
// module id = R4C7
// module chunks = 14